module.exports = __webpack_public_path__ + "static/img/18.1fcd7e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/18.png
// module id = pI5T
// module chunks = 0